<span class="p-inputgroup inline">
  @if (confirming && questionText) {
    <span
      class="p-inputgroup-addon"
      data-purpose="question">
      {{ questionText }}
    </span>
  }
  @if (confirming) {
    <button pButton
      [severity]="cancelSeverity"
      [icon]="cancelIcon"
      [label]="iconsOnly ? null : cancelText"
      [title]="cancelText ?? ''"
      (click)="DoCancel(); $event.preventDefault()"
      data-purpose="cancel"
      tabindex="-1"
    [ngClass]="{ 'p-button-sm': size === 'sm' }"></button>
  }
  <button pButton
    [severity]="confirming ? confirmSeverity : actionSeverity"
    [disabled]="isDisabled"
    [icon]="DisplayIcon()"
    [label]="iconsOnly ? null : (confirming ? confirmText : actionText)"
    [title]="(confirming ? confirmText : actionText) ?? ''"
    (click)="DoAction(); $event.preventDefault()"
    data-purpose="action"
    [attr.role]="iconsOnly ? 'button' : ''"
    [attr.label]="iconsOnly ? (confirming ? confirmText : actionText) : ''"
    [ngClass]="{ 'p-button-sm': size === 'sm' }"
  tabindex="-1"></button>
</span>
